// [CF 2026-07-28] Client: cars were showing the wrong picture in the Manage
// (My Posts) list and in the Car Dealer view, on both the app and the website.
//
// Every call site picked its image differently — one took `carMedia[0]`
// (whichever row the API happened to return first, often an interior shot or a
// document), another matched LOGO before any of the car-photo types, so a
// dealer logo could win over the actual car. Nothing preferred MAIN_BANNER,
// which is the image the vendor actually nominates as the primary photo and the
// one the detail page and the iOS app show.
//
// One preference order, used everywhere:
//   MAIN_BANNER -> BANNER -> car photo types -> LOGO -> whatever exists
const PREFERENCE = [
  'MAIN_BANNER',
  'BANNER',
  'CAR-IMAGES',
  'CAR_IMAGE',
  'IMAGES',
  'LOGO',
];

export function pickCarImage(mediaList) {
  const list = Array.isArray(mediaList) ? mediaList : [];
  for (const type of PREFERENCE) {
    const hit = list.find((m) => m?.mediaType === type && m?.media?.path);
    if (hit) return hit.media.path;
  }
  return list.find((m) => m?.media?.path)?.media?.path;
}

export default pickCarImage;
